// extracted by mini-css-extract-plugin
export default {"groupName":"GroupIcon_groupName__NtZ5W","groupNameTrim":"GroupIcon_groupNameTrim__P5RE-"};